function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import * as R from 'unitx/ramda';
import { wrapComponent } from 'unitx-ui';
import View from "../View";

// const PressablePIXI = PixiComponent<PressableProps, PIXI.Container>('PressablePIXI', {
//   create: () => {
//     const mutableInstance = new PIXI.Container()
//     mutableInstance.interactive = true
//     mutableInstance.buttonMode = true
//     return mutableInstance
//   },
//   applyProps: (
//     instance: PIXI.Graphics,
//     oldProps,
//     _props,
//   ) => applyDefaultProps(instance, oldProps, preprocessProps(_props))
//   ,
// })
function Pressable(props) {
  const {
    // onLongPress,
    // onPress,
    // onDoublePress,
    // onHoverEnd,
    // onHoverStart,
    // onPressChange,
    // onPressEnd,
    // onPressMove,
    // onPressStart,
    buttonMode
  } = props,
        rest = _objectWithoutProperties(props, ["buttonMode"]); // const events = useEvents(
  //   R.omitBy(R.isNil, {
  //     onLongPress,
  //     onPress,
  //     onDoublePress,
  //     onHoverEnd,
  //     onHoverStart,
  //     onPressChange,
  //     onPressEnd,
  //     onPressMove,
  //     onPressStart,
  //   }),
  //   {
  //     extraData: [
  //       onLongPress,
  //       onPress,
  //       onDoublePress,
  //       onHoverEnd,
  //       onHoverStart,
  //       onPressChange,
  //       onPressEnd,
  //       onPressMove,
  //       onPressStart,
  //     ],
  //   },
  // )


  const viewRef = React.useRef(null);
  React.useEffect(() => {
    R.when(R.isNotNil, () => {
      const mutableContainer = viewRef.current;
      mutableContainer.buttonMode = !!buttonMode;
      mutableContainer.interactive = true;
    })(viewRef.current);
  }, [viewRef, buttonMode]);
  return /*#__PURE__*/React.createElement(View, _extends({
    ref: viewRef
  }, rest));
}
/**
 * ## Usage
 * To use Text on Graph
 * Check example
 *
 * ```js live=true
 * <Graph
 *  style={{ width: '100%', height: 250 }}
 *  nodes={[
 *    {
 *      id: 1,
 *      position: { x: 10, y: 10 },
 *      data: { city: 'Amsterdam' }
 *    },
 *    {
 *      id: 2,
 *      position: { x: 300, y: 10 },
 *      data: { city: 'Maastricht' }
 *    },
 *  ]}
 *  edges={[
 *    { id: 51, source: 1, target: 2 }
 *  ]}
 *  renderNode={({ item: { data } }) => (
 *    <Graph.Pressable
 *      onPress={() => alert('Pressed!!')}
 *      onLongPress={() => alert('LongPressed!!')}
 *    >
*       <Graph.View
 *         style={{ width: 100, height: 100,  }}
 *       >
 *         <Graph.Text
 *            style={{ fontSize: 18 }}
 *          >
 *           {data.city}
 *          </Graph.Text>
 *       </Graph.View>
 *    </Graph.Pressable>
 * )}
 * />
 * ```
 */


export default wrapComponent(Pressable, {});